<template>
  <div class="pe-semester-study-grade-editor">
    <div class="body">
      <el-select :loading="loading"
                 loading-text="学年加载中..."
                 filterable
                 clearable
                 v-bind="$attrs"
                 v-on="$listeners">
        <template v-if="studyGrades">
          <el-option v-for="studyGrade in studyGrades"
                     :key="studyGrade.id"
                     :label="studyGrade.name"
                     :value="studyGrade.id"></el-option>
        </template>
      </el-select>
    </div>
    <div class="tail">
      <PeSemesterStudyGradeAdd @add-success="loadStudyGrades">
        <template #default="{toggleVisible}">
          <el-button size="mini"
                     type="text"
                     icon="el-icon-circle-plus-outline"
                     @click="toggleVisible"></el-button>
        </template>
      </PeSemesterStudyGradeAdd>
    </div>
  </div>
</template>

<script>
import PeSemesterStudyGradeAdd from './add'
export default {
  name: 'PeSemesterStudyGradeEditor',
  components: {
    PeSemesterStudyGradeAdd
  },
  data () {
    return {
      loading: false,
      studyGrades: null
    }
  },
  methods: {
    loadStudyGrades () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/data/select/studyGrades',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.studyGrades = response.data.studyGrades || []
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadStudyGrades()
  }
}
</script>

<style lang="scss">
  .pe-semester-study-grade-editor {
    display: flex;
    align-items: center;
    & > .body {
      flex: auto;
      .el-select {
        width: 100%;
      }
    }
    & > .tail {
      margin-left: 10px;
      flex: none;
      .el-button {
        font-size: 14px;
      }
    }
  }
</style>
